import { useHistory } from "react-router-dom";
import { apiFetch, FetchTypes } from "../../api/core";
import { login, useUser } from "../../userContext/UserContext";

export interface LoginAs {
  getToken: (userId: string) => Promise<string>;
  loginAs: (userId: string) => void;
}

export const useLoginAs = (apiPath: string, redirectTarget: string): LoginAs => {
  const history = useHistory();
  const userContext = useUser();

  const getToken = (userId: string) =>
    apiFetch<string>(`${apiPath}/${userId}`, FetchTypes.POST);

  const loginAs = (userId: string) =>
    getToken(userId)
      .then(token => {
        login(userContext, token);
        history.replace(redirectTarget)
      });

  return { loginAs, getToken };
}